import $ from 'zepto';
import { onDocumentReady } from '../../main';

const $body = $(document.body);

export function initPasswordField($context = $body) {
  const $passwordInputAnchor = $($context).find('.ui-action-password');
  if ($passwordInputAnchor.length) {
    const eyeOpenClass = 'ui-action-password-visible';

    const onClick = (event) => {
      const $target = $(event.target);
      event.preventDefault();
      const $passwordInput = $target.parent('div').children('input');
      if ($passwordInput.attr('type') === 'password') {
        $passwordInput.attr('type', 'text');
        $target.addClass(eyeOpenClass);
      } else if ($passwordInput.attr('type') === 'text') {
        $passwordInput.attr('type', 'password');
        $target.removeClass(eyeOpenClass);
      }
    };

    $passwordInputAnchor.off();
    $passwordInputAnchor.on('click', onClick);
  }
}

// TODO: Add context implementation
onDocumentReady('PasswordField', () => {
  initPasswordField();
});

export default {
  initPasswordField,
};
